import { gql } from 'apollo-angular'

import { AUTHOR_COMPLETE_FIELDS } from '../../fragments/author.fragments'

export const GET_AUTHOR_BY_ID = gql`
  ${AUTHOR_COMPLETE_FIELDS}
  query getAuthorById($id: Int!) {
    Author(id: $id) {
      ...AuthorCompleteFields
    }
  }
`
